import { SortDirection } from "@angular/material/sort";

/** Microsoft Graph device resource property names for $select (users/{id}/owned-devices). */
export const DEVICE_SELECT_FIELDS: string[] = [
    'id',
    'deviceId',
    'displayName',
    'operatingSystem',
    'operatingSystemVersion',
    'isCompliant',
    'approximateLastSignInDateTime',
    'registrationDateTime',
    'manufacturer',
    'model',
];

export const DEFAULT_ORDER_BY = 'displayName';
export const DEFAULT_ORDER_DIRECTION: SortDirection = 'asc';
export const DEFAULT_TOP = 5;